import React, { useState } from 'react';
import classes from './product.module.scss';
import Stepper from '../stepper/stepper';
import Section from '../section/section';
import Share from '@material-ui/icons/Share';
import { Query } from 'react-apollo';
import { Link, navigate } from '@reach/router';
import Stars from '../stars/stars';
import Like from '../like/like';
import {
  GET_PRODUCT,
  FIND_CHAT,
  GET_PRODUCTS_BY_BAKER,
  GET_SEEN_PRODUCTS
} from '../../queries';
import Slider from 'react-slick';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import CreateChat from '../chat/create-chat';
import gql from 'graphql-tag';
import MutationOnMount from '../HOCs/mutateOnMount';
import { SnackbarContent } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

const ADD_TO_SEEN_PRODUCTS = gql`
  mutation addToSeenProducts($id: String!) {
    addToSeenProducts(productId: $id) {
      id
      name
      imagesUrls
      price
    }
  }
`;

const settings = {
  infinite: true,
  autoplay: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1
};

const Product = (props: any) => {
  const [open, setOpen] = useState(
    props.location.search === '?showMessageForm'
  );

  const id = props.product;

  return (
    <div className={classes.product}>
      {/* for some reason we need to add fetch-policy even if we have set it globally in apollo.ts file to be network-only */}
      <Query query={GET_PRODUCT} variables={{ id }} fetchPolicy="network-only">
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            );
          }
          if (error) {
            navigate('/404');
            return null;
          }
          const { product } = data;
          const productImages = product.imagesUrls.map(
            (url: string, i: number) => ({
              id: i,
              image: url
            })
          );

          return (
            <div>
              <MutationOnMount
                mutation={ADD_TO_SEEN_PRODUCTS}
                variables={{ id }}
                refetchQueries={[{ query: GET_SEEN_PRODUCTS }]}
              />

              <Slider {...settings}>
                {productImages.map((productImg: any) => (
                  <div key={productImg.id} className={classes.productImg}>
                    <img src={productImg.image} />
                  </div>
                ))}
              </Slider>
              {product.active ? null : (
                <SnackbarContent
                  className={classes.snackbar}
                  message={
                    <span id="client-snackbar" className={classes.message}>
                      <InfoIcon className={classes.infoIcon} />
                      Цей товар неактивний
                    </span>
                  }
                />
              )}
              <div className={classes.productInfo}>
                <div className={classes.productDesc}>
                  <h2 data-e2e-id={'product-name'}>{product.name}</h2>
                  <Stars
                    stars={product.stars}
                    reviews={product.reviews.length}
                  />
                  <div className={classes.price} data-e2e-id={'product-price'}>
                    {product.price} ₴
                  </div>
                  <p style={{ whiteSpace: 'pre-wrap' }}>
                    {product.description}
                  </p>
                </div>
                {product.user ? (
                  <div className={classes.ownerProduct}>
                    <Link to={'/baker/' + product.user.username}>
                      <img
                        src={
                          product.user.image || '/assets/profile_default.png'
                        }
                        className={classes.img}
                      />
                    </Link>
                    <div className={classes.cartBody}>
                      <h3>
                        <Link to={'/baker/' + product.user.username}>
                          {product.user.firstName}
                        </Link>
                      </h3>
                      <Stars
                        stars={product.user.stars}
                        reviews={product.reviews.length}
                      />
                    </div>
                  </div>
                ) : null}
                <div className={classes.productOrder}>
                  {product.own ? null : localStorage.getItem('token') ? (
                    <Query query={FIND_CHAT} variables={{ productId: id }}>
                      {result => {
                        if (result.loading) {
                          return (
                            <div style={{ textAlign: 'center' }}>
                              <CircularProgress />
                            </div>
                          );
                        }
                        if (result.error) {
                          return <div>Error fetching chat</div>;
                        }
                        const chatId = result.data.findChat;

                        const clickAction = chatId
                          ? () => navigate(`/mailbox/${chatId}`)
                          : () => setOpen(true);

                        return (
                          <>
                            <Button
                              disabled={!product.active}
                              variant="contained"
                              color="primary"
                              data-e2e-id={'contact-seller-button'}
                              className={classes.button}
                              onClick={clickAction}
                            >
                              Написати продавцеві
                            </Button>
                            <CreateChat
                              open={open}
                              setOpen={setOpen}
                              productId={id}
                              product={product}
                            />
                          </>
                        );
                      }}
                    </Query>
                  ) : (
                    <Button
                      disabled={!product.active}
                      variant="contained"
                      color="primary"
                      data-e2e-id={'contact-seller-login'}
                      className={classes.button}
                      onClick={() =>
                        navigate('/login', {
                          state: {
                            redirectAfterLogin:
                              props.location.href + '?showMessageForm'
                          }
                        })
                      }
                    >
                      Написати продавцеві
                    </Button>
                  )}
                  <div className={classes.icons}>
                    <div>
                      <Share className={classes.icon} />
                    </div>
                    <Like
                      productId={product.id}
                      isFavorite={product.isFavorite}
                    />
                  </div>
                </div>
              </div>
              <Query
                query={GET_PRODUCTS_BY_BAKER}
                variables={{ bakerId: product.user.username }}
              >
                {response => {
                  if (response.loading) {
                    return (
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress />
                      </div>
                    );
                  }
                  if (response.error) return <div>Error fetching products</div>;

                  const products = response.data.productsByBaker.filter(
                    p => p.id !== id
                  );
                  if (products.length) {
                    const productsWithOneImage = products.map((p: any) => ({
                      ...p,
                      image: p.imagesUrls[0]
                    }));
                    return (
                      <Section
                        title={'Інші пропозиції цього пекаря'}
                        count={products.length}
                        click={() =>
                          navigate(`/baker/${product.user.username}?all=true`)
                        }
                      >
                        <Stepper steps={productsWithOneImage} />
                      </Section>
                    );
                  } else {
                    return null;
                  }
                }}
              </Query>
            </div>
          );
        }}
      </Query>
    </div>
  );
};

export default Product;
